import PropTypes from 'prop-types';
import React from 'react';
import Label from './label';
import { convertToHexString } from '../utils';
import entityComposition from '../../common/classes/entityComposition';
import { labelSelector, valueSelector } from '../selectors';
const getColor = color => {
  if (typeof color === 'object') {
    return convertToHexString(color);
  }
  return color;
};

/* eslint-disable-next-line default-param-last */
const styleWrapper = function styleWrapper() {
  let styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let text = arguments.length > 1 ? arguments[1] : undefined;
  let wrappedText = text;
  const supportedStyles = {
    bold: words => /*#__PURE__*/React.createElement("b", null, words),
    italic: words => /*#__PURE__*/React.createElement("i", null, words),
    uppercase: words => /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: 'uppercase'
      }
    }, words),
    underline: words => /*#__PURE__*/React.createElement("span", {
      style: {
        textDecoration: 'underline'
      }
    }, words),
    code: words => /*#__PURE__*/React.createElement("span", {
      style: {
        whiteSpace: 'pre-wrap'
      }
    }, words)
  };
  Object.keys(supportedStyles).forEach(key => {
    if (styles[key]) {
      wrappedText = supportedStyles[key](wrappedText);
    }
  });
  return wrappedText;
};

/**
 * @class TextView
 */
const TextView = _ref => {
  let _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  const styles = {
    textAlign: attributes.align || 'left',
    whiteSpace: 'pre-line' // ensure line-breaks ("\n") are respected
  };
  // bottom alignment is not supported by textAlign, so we set a margin bottom to 1px
  if (attributes.align === 'bottom') styles.marginBottom = '1px';
  if (attributes.backgroundColor) {
    styles.backgroundColor = getColor(attributes.backgroundColor);
  }
  if (attributes.textColor) {
    styles.color = getColor(attributes.textColor);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), /*#__PURE__*/React.createElement("p", {
    style: styles
  }, styleWrapper(attributes.style, value)));
};
TextView.propTypes = {
  attributes: PropTypes.shape({
    align: PropTypes.string,
    backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    style: PropTypes.shape({
      bold: PropTypes.bool,
      italic: PropTypes.bool,
      uppercase: PropTypes.bool
    }),
    textColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }),
  label: PropTypes.string,
  value: PropTypes.string
};
export { TextView as UncomposedTextView };
export default entityComposition(TextView, [], {
  label: labelSelector,
  value: valueSelector
});